module.exports = __webpack_public_path__ + "static/media/ClockIcon.3b65d9d6.svg";